import {
    createFormGroupState, formGroupReducer, FormGroupState, updateGroup, validate
} from 'ngrx-forms';
import { required } from 'ngrx-forms/validation';

import {
    dateGreaterThan, dateLessThan
} from '../../../../shared/ngrx-forms-extensions/validation-functions';
import { ValidDocuments } from '../valid-documents.model';
import {
    CheckRequirementsFormValue, getCheckRequirementsFormInitialValue
} from './check-requirements-form-value';
import {
    CheckRequirementsAction, CheckRequirementsActionTypes
} from './check-requirements.actions';

export const CHECK_REQUIREMENTS_FORM_ID = 'checkRequirementsForm';

export interface CheckRequirementsState {
    form: FormGroupState<CheckRequirementsFormValue>;
    validDocuments: ValidDocuments;
    validDocumentsLoaded: boolean;
    showPopup: boolean;
}

export const getCheckRequirementsInitialValue = () => {
    return {
        form: createFormGroupState<CheckRequirementsFormValue>(CHECK_REQUIREMENTS_FORM_ID, getCheckRequirementsFormInitialValue()),
        validDocuments: null,
        showPopup: false,
    } as CheckRequirementsState;
};

const validateForm = (formState: FormGroupState<CheckRequirementsFormValue>) => {
    return updateGroup(formState, {
        from: (controlState, parentState) => {
            controlState = validate(controlState, required, dateLessThan(parentState.value.to));
            return controlState;
        },
        to: (controlState, parentState) => {
            controlState = validate(controlState, required, dateGreaterThan(parentState.value.from));
            return controlState;
        },
        userId: validate(required),
        countryId: validate(required)
    });
};

export function checkRequirementsReducer(state = getCheckRequirementsInitialValue(),
    action: CheckRequirementsAction): CheckRequirementsState {

    const form = validateForm(formGroupReducer(state.form, action));
    if (form !== state.form) {
        state = {
            ...state,
            form,
            validDocuments: {
                certifications: [],
                publicHealthRecords: []
            },
            validDocumentsLoaded: false
        };
    }

    switch (action.type) {
        case CheckRequirementsActionTypes.LoadValidDocumentsSuccess: {
            return {
                ...state,
                validDocuments: action.validDocuments,
                validDocumentsLoaded: true
            };
        }
        case CheckRequirementsActionTypes.ClearCheckRequirements: {
            return {
                ...state,
                validDocuments: null,
                validDocumentsLoaded: false
            };
        }
        case CheckRequirementsActionTypes.ShowCheckRequirementsPopup:
            return {
                ...state,
                showPopup: true,
            };

        case CheckRequirementsActionTypes.HideCheckRequirementsPopup:
            return { ...state, showPopup: false };

        default:
            return state;
    }
}
